export default __webpack_public_path__ + "static/media/sort-icon-up.0e896ffb.svg";